// storageService.ts
import { Storage, Drivers } from '@ionic/storage';
import {
  KEY_PARENT_DETAILS,
  KEY_USER_DETAILS,
  KEY_USER_CHANGE_LANG,
  KEY_FIRE_REG_TOKEN,
  KEY_ACCESS_TOKEN,
  KEY_LOGIN_ACCESS_TOKEN,
} from './Helpers/constant';

const storage = new Storage({
  name: "__user",
  driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
});

storage.create();

export const getUserDetails = () => {
  const user = localStorage.getItem("userDetails");
  return user ? JSON.parse(user) : null;
};

export const getParentDetails = () => {
  const user = localStorage.getItem(KEY_PARENT_DETAILS);
  return user ? JSON.parse(user) : null;
};

export const getUserChangeLang = () => {
  const flag = localStorage.getItem(KEY_USER_CHANGE_LANG);
  return flag ? JSON.parse(flag) : null;
};

export const logOut = (config: any, history: any) => {
  const userDetails = getUserDetails();
  const url = 'https://edison-portal-api.turboverse.co/api/v1/log/lastactivetime';
  const payload = { contactId: userDetails.ContactId };

  if (navigator.sendBeacon) {
    const blob = new Blob([JSON.stringify(payload)], {
      type: 'text/plain; charset=UTF-8',
    });
    navigator.sendBeacon(url, blob);
  } else {
    const req = new XMLHttpRequest();
    req.open('POST', url, false);
    req.setRequestHeader('Content-Type', 'application/json');
    req.send(JSON.stringify(payload));
  }

  setTimeout(() => {
    localStorage.removeItem(KEY_FIRE_REG_TOKEN);
    localStorage.removeItem(KEY_USER_DETAILS);
    localStorage.removeItem(KEY_PARENT_DETAILS);
    localStorage.removeItem(KEY_LOGIN_ACCESS_TOKEN);
    sessionStorage.clear();
    localStorage.clear();
    history.push('/');
  }, 1000);
};


export const getAccessToken = () => {
  return localStorage.getItem(KEY_ACCESS_TOKEN);
};


export default storage;